/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import { useLazyQuery, useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useAutosuggestOptions from "hooks/useAutosuggestOptions";
import useInferLabelCreditByUrl from "hooks/useInferLabelCreditByUrl";
import useRegenerateScreenshotMetadataField from "hooks/useRegenerateScreenshotMetadataField";
import useUser from "hooks/useUser";
import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const { homeVideos: { GET_HOME_VIDEOS }, vendors: { SEARCH_LABELS, SEARCH_STORES } } = queries;
const { homeVideos: { ADD_HOME_VIDEO } } = mutations;
const usePrepareComponent = () => {
    const history = useHistory();
    const [selectedLabelId, setSelectedLabelId] = useState();
    const [selectedStoreIds, setSelectedStoreIds] = useState([]);
    const { isAdmin, isEditor } = useUser();
    const [addHomeVideo, { loading: addHomeVideoLoading }] = useMutation(ADD_HOME_VIDEO, { refetchQueries: [GET_HOME_VIDEOS] });
    const [getHomeVideos] = useLazyQuery(GET_HOME_VIDEOS);
    const onInferScreenshotCredit = useInferLabelCreditByUrl();
    const { onRegenerateScreenshotMetadataField } = useRegenerateScreenshotMetadataField();
    const [searchLabels, { data: searchLabelsData, loading: labelsSuggestionsLoading }] = useLazyQuery(SEARCH_LABELS);
    const [searchStores, { data: searchStoresData, loading: searchStoresLoading }] = useLazyQuery(SEARCH_STORES);
    const onCancel = () => {
        history.push("/home-videos/home-videos");
    };
    /**
     * Selects a label by ID
     *
     * @param id
     */
    const onSelectLabelId = (id) => {
        setSelectedLabelId(id);
    };
    /**
     * Selects a store by ID
     *
     * @param index
     */
    const onSelectStoreId = (index) => (id) => {
        /**
         * TODO: Maybe we can do something nice to ensure uniqueness of one
         * store per link? Do we even want to?
         * If we do we also want the dropdowns to only present stores that
         * we haven't selected
         * And what if we need 2 or more of the same store?
         */
        setSelectedStoreIds((prev) => {
            /**
             * Find index of store link with same index
             */
            const presentIndex = prev.findIndex((item) => item.index === index);
            /**
             * If we have a store link with the same index, we update it
             */
            if (presentIndex >= 0) {
                const next = prev.slice();
                next[presentIndex] = { id, index };
                return next;
            }
            /**
             * If we don't have a store link with same index
             * we add a new one
             */
            return [...prev, { id, index }];
        });
    };
    /**
     * Label suggestions for autosuggest input.
     *
     * @param root0
     * @param root0.inputValue
     */
    const onGetLabelsSuggestions = ({ inputValue }) => {
        searchLabels({
            variables: {
                searchLabelsInput: { name: inputValue }
            }
        });
    };
    /**
     * Store suggestions for autosuggest input.
     *
     * @param root0
     * @param root0.inputValue
     */
    const onGetStoresSuggestions = ({ inputValue }) => {
        searchStores({
            variables: {
                searchStoresInput: {
                    url: inputValue
                }
            }
        });
    };
    /**
     * Saves home video and store links.
     *
     * @param itemUpdate
     * @param storeLinksUpdate
     */
    const onSave = (itemUpdate, storeLinksUpdate) => {
        if (!itemUpdate.name || !itemUpdate.images) {
            return;
        }
        const getIsScreenshotsAddInput = (screenshots) => screenshots?.every((screenshot) => Boolean(screenshot.originalUrl)) ??
            false;
        const itemAdd = {
            ...itemUpdate,
            images: itemUpdate.images ?? [],
            screenshots: getIsScreenshotsAddInput(itemUpdate.screenshots)
                ? itemUpdate.screenshots
                : [],
            isBluRay: Boolean(itemUpdate.isBluRay),
            isPublished: Boolean(itemUpdate.isPublished),
            isUHD: Boolean(itemUpdate.isUHD),
            name: itemUpdate.name
        };
        const storeLinksAdd = storeLinksUpdate?.filter((storeLink) => Boolean(storeLink.storeId));
        addHomeVideo({
            onCompleted: () => {
                getHomeVideos({
                    fetchPolicy: "network-only",
                    onCompleted: () => {
                        history.push("/home-videos/home-videos");
                    }
                });
            },
            variables: {
                homeVideoAddInput: itemAdd,
                storeLinksAddInput: storeLinksAdd
            }
        });
    };
    /**
     * Generates options for the label autosuggest input.
     */
    const autosuggestLabels = useAutosuggestOptions({
        suggestions: searchLabelsData?.searchLabels.map((item) => ({
            id: item.id,
            name: item.vendor.name
        })) ?? []
    });
    /**
     * Generates options for the vendor autosuggest input.
     */
    const autosuggestStores = useAutosuggestOptions({
        suggestions: searchStoresData?.searchStores?.map((item) => ({
            id: item.id,
            name: item.url ?? ""
        }))
    });
    const storeOptionsById = useMemo(() => ({}), []);
    return {
        isAdmin,
        isEditor,
        isLabelsSuggestionsLoading: labelsSuggestionsLoading,
        isSaveLoading: addHomeVideoLoading,
        isStoresSuggestionsLoading: searchStoresLoading,
        labels: autosuggestLabels,
        onCancel,
        onGetLabelsSuggestions,
        onGetStoresSuggestions,
        onInferScreenshotCredit,
        onRegenerateScreenshotMetadataField,
        onSave,
        onSelectLabelId,
        onSelectStoreId,
        selectedLabelId,
        selectedStoreIds,
        storeOptionsById,
        stores: autosuggestStores
    };
};
export default prepareComponent(usePrepareComponent)(Add);
